import { useContext } from 'react';
import { useGoalsAnswersExperimentApi } from '@hungryroot/exp-152-goals-value-prop';
import { ControlSelect } from '../../components/ControlSelect/ControlSelect';
import { QuizQuestionScreen } from '../../components/QuizQuestionScreen/QuizQuestionScreen';
import { SectionLabel } from '../../components/SectionLabel/SectionLabel';
import { Toggle, ToggleVariant } from '../../components/Toggle/Toggle/Toggle';
import { Goals } from '../../defs/quiz';
import { QuizContext } from '../../quiz-context';

import { shuffleArray } from '../../utils/shuffleArray';

import styles from '../layout.module.css';

interface Props {
  testid: string;
}

const defaultGoalsAnswers = [
  {
    label: 'Save time',
    value: Goals.SaveTime,
  },
  {
    label: 'Improve health',
    value: Goals.ImproveHealth,
  },
  {
    label: 'Lose weight',
    value: Goals.LoseWeight,
  },
  {
    label: 'Try new things',
    value: Goals.TryNewThings,
  },
  {
    label: 'Grocery shop less',
    value: Goals.GroceryShopLess,
  },
  {
    label: 'Waste less food',
    value: Goals.WasteLessFood,
  },
  {
    label: 'Simplify cooking',
    value: Goals.SimplifyCooking,
  },
  {
    label: 'Save money',
    value: Goals.SaveMoney,
  },
];
const shuffledDefaultOptions = shuffleArray(defaultGoalsAnswers);

export function HelloGoals(props: Props) {
  const { testid } = props;

  const { quiz } = useContext(QuizContext);

  const { shuffledGoalsOptions, goals } =
    useGoalsAnswersExperimentApi(shuffledDefaultOptions, quiz.goals) || {};

  return (
    <QuizQuestionScreen
      testid={testid}
      heroText="What are your goals with Hungryroot?"
      subCopy="Select 3 that are most important to you."
      sectionLabel={<SectionLabel label="About you" />}
    >
      <div
        data-testid={`${testid}-question-goals`}
        className={styles['bottom-padding']}
      >
        <ControlSelect
          question="goals"
          max={3}
          defaultValue={[]}
          layoutVariant="two-column-desktop"
          ariaLabel="Select your goals"
          items={shuffledGoalsOptions}
          selectedKeys={goals}
        >
          {shuffledGoalsOptions &&
            goals &&
            shuffledGoalsOptions.map(({ label, value }, i) => {
              const isActive = goals.includes(value);
              return (
                <ControlSelect.Option id={value} key={value} label={label}>
                  <Toggle
                    active={isActive}
                    testid={`${testid}-toggle-goal-${value}`}
                    label={label}
                    variant={ToggleVariant.Two}
                    style={{ animationDelay: `${0.05 * i + 0.5}s` }}
                  />
                </ControlSelect.Option>
              );
            })}
        </ControlSelect>
      </div>
    </QuizQuestionScreen>
  );
}
